import { useEffect, useState } from "react";
import PageHeader from "../../global-layout/page-header";
import OptionOneMain from "../option-one-main";
import { directService, processService } from "../../../services/InspectionOneServices";
import { useParams } from "react-router-dom";
import { ToastError, ToastSuccess, ToastWarning } from "../../UI/toast";
import ToastifyMessage from "../../../lib/toastify";
import PageLoader from "../../UI/page-loader";
import { useTranslation } from "react-i18next";
import fullProcess from "../../../fullProcess.json"
import { headerValues, requestDetails } from "../../../services/authService";

function OptionOneWrapper() {
  const { t } = useTranslation();
  const { authToken } = useParams();
  const { ToastifyHandle } = ToastifyMessage();
  const { siteUniqueId, languageCode } = useParams();
  const [allProcessData, setAllProcessData] = useState<any>();
  const [allGetStarted, setAllGetStarted] = useState<any>();
  const [overridden, setoverridden] = useState<any>();
  const [authTokenDetails, setAuthTokenDetails] = useState<any>();
  const [isGetStartedAvailable, setIsGetStartedAvailable] = useState<any>();
  const [interactionConfigurations, setInteractionConfigurations] = useState<any>();
  const [isLoading, setIsLoading] = useState(false);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [pageLoader, setPageLoader] = useState(false);
  const [isViewOnly, setIsViewOnly] = useState(0);
  const processLanuage = t("web.common.process");
  const requiredFieldValidation = t("web.common.required");
  const videoFieldValidation = t("web.common.videoFieldValidation");
  const audioFieldValidation = t("web.common.audioFieldValidation");
  const imageFieldValidation = t("web.common.imageFieldValidation");

  sessionStorage.setItem("siteUniqueId", siteUniqueId || "");
  sessionStorage.setItem("languageCode", languageCode || "");


  const [validationErrors, setValidationErrors] = useState<{
    [key: string]: string;
  }>({});

  const initialFetch = async () => {
    setPageLoader(true);
    setIsLoading(true);
    setDownloadLoading(true);
    try {
      const requestJson = {
        authToken: authToken,
      };
      const response = await processService.ProcessRegistryWebFetch(
        requestJson
      );
      const responseData = response.data;
      if (response.success) {
        // const responseData = fullProcess;
        //   if (true) {
        setAllProcessData(responseData);
        sessionStorage.setItem(
          "image",
          responseData.authTokenDetails[0].userProfileImage || ""
        );
        setIsGetStartedAvailable(
          responseData.screenDetail.isGetStartedAvailable
        );
        setInteractionConfigurations(responseData.screenDetail.interactionConfigurations)
        setAllGetStarted(responseData.getStartedData);
        if (responseData.authTokenDetails[0].userType) {
          setIsViewOnly(
            responseData.authTokenDetails[0].userType === "External"
              ? 1
              : responseData.screenDetail.isOnlyMagicContainer
          );
        }
        setoverridden(responseData.isOverridden);
        setAuthTokenDetails(responseData.authTokenDetails);
        setIsLoading(false);
        setPageLoader(false);
        setDownloadLoading(false);
      } else {
        // if (response.message === "AuthToken has expired.") {
        //   handleError(processLanuage, t("web.common.authtoken"));
        // } else {
        //   handleError(processLanuage, t("web.common.somethingwentwrong"));
        // }
        setIsLoading(false);
        setPageLoader(false);
        setDownloadLoading(false);
        console.error("Error fetching data:");
      }
    } catch (error) {
      handleError(processLanuage, t("web.common.somethingwentwrong"));
      setIsLoading(false);
      setPageLoader(false);
      setDownloadLoading(false);
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    initialFetch();
    sessionStorage.setItem("language", languageCode || "en");
  }, []);

  useEffect(() => { }, [allProcessData]);

  useEffect(() => { }, [allGetStarted]);

  const validateField = (question: any, answer: any) => {
    let errors: any = {};
    if (question.isMandatory) {
      if (question.type === 9 && question.subType === 3) {
        if (!answer.defaultAnswer || answer.defaultAnswer.length === 0) {
          errors[question.id] = requiredFieldValidation;
        }
      } else if (question.type === 12) {
        if (!answer.defaultAnswer || answer.defaultAnswer.length === 0) {
          errors[question.id] = requiredFieldValidation;
        }
      } else {
        if (!answer.defaultAnswer || answer.defaultAnswer.length === 0) {
          errors[question.id] = requiredFieldValidation;
        }
      }
    }
    return errors;
  };

  const validateAllFields = (mainScreenDetails: any, answerDetail: any) => {
    let errors: any = {};

    mainScreenDetails.forEach((screen: any) => {
      const questionDetails = screen.questionDetails;
      let screenErrors = {};

      questionDetails.forEach((question: any) => {
        const fieldErrors = validateField(
          question,
          answerDetail[screen.id]?.[question.id]
        );
        screenErrors = { ...screenErrors, ...fieldErrors };
      });

      if (Object.keys(screenErrors).length > 0) {
        errors[screen.id] = screenErrors;
      }
    });

    return errors;
  };

  const handleSubmit = async () => {
    const mainScreenDetails = allProcessData?.screenDetail?.mainScreenDetails;
    const answerDetail = allProcessData?.screenDetail?.answerDetail;
    const errors = validateAllFields(mainScreenDetails, answerDetail);
    setValidationErrors(errors);
    if (Object.keys(errors).length === 0) {
      setIsLoading(true);
      try {
        const response = await processService.ProcessRegistryWebAction(
          allProcessData
        );
        if (response.success) {
          handleSuccess(processLanuage, t("web.common.successfullyupdated"));
        } else {
          handleError(processLanuage, t("web.common.somethingwentwrong"));
        }
        setIsLoading(false);
      } catch (error) {
        handleError(processLanuage, t("web.common.somethingwentwrong"));
        console.error("Error fetching data:", error);
        setIsLoading(false);
      }
    } else {
      return;
    }
  };
  const handleSuccess = (titleName: any, message: any) => {
    ToastifyHandle(
      <ToastSuccess title={titleName} description={message} />,
      "success"
    );
  };
  const handleError = (titleName: any, message: any) => {
    ToastifyHandle(
      <ToastError title={titleName} description={message} />,
      "error"
    );
  };
  const handleWarning = (titleName: any, message: any) => {
    ToastifyHandle(
      <ToastWarning title={titleName} description={message} />,
      "warning"
    );
  };
  const getDisplayValue = (value: any): string => {
    if (value === null || value === undefined) return "";
    if (typeof value === "string" || typeof value === "number" || typeof value === "boolean") {
      return String(value);
    }
    if (Array.isArray(value)) {
      return value.map(getDisplayValue).filter(Boolean).join(", ");
    }
    if (typeof value === "object") {
      if (value.name || value.label || value.value || value.title) {
        return String(value.name || value.label || value.value || value.title);
      }
      if (Array.isArray(value.annotatedDetails)) {
        return `${value.annotatedDetails.length} annotation${value.annotatedDetails.length === 1 ? "" : "s"}`;
      }
    }
    return "";
  };

  const handleExportClick = async () => {
    setDownloadLoading(true);
    try {
      const requestJson = {
        id: allProcessData.processId,
        processLogicId: allProcessData.processLogicId,
        subProcessLogicId: allProcessData.subProcessLogicId,
      };
      const response: any = await processService.ProcessExportAction(
        requestJson
      );
      const link = document.createElement("a");
      link.href = response.data;
      link.setAttribute("download", "exported_file_name.extension");
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      setDownloadLoading(false);
    }
  };

  const handlePDFExportClick = async () => {
    debugger;
    setDownloadLoading(true);
    try {
      const requestJson = {
        authToken: authToken,
      };
      const headers = headerValues.getHeaders("");
      const response = await fetch(interactionConfigurations.pdfExportUrl, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(requestDetails(requestJson))
      });

      if(response.ok){
        const blob = await response.blob();
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'inspection One Report.pdf'; // set your filename here
        link.click();

        link.remove();
        URL.revokeObjectURL(url); // clean up memory
      }
      else{
        handleError(processLanuage, t("web.common.somethingwentwrong"));
      }
      debugger;
      setDownloadLoading(false);

    } catch (error) {
      setDownloadLoading(false);
    }
  };
  return (
    <div className="w-full h-auto">
      <PageHeader
        title={getDisplayValue(allGetStarted?.[0]?.labelValue)}
        hasSaveBtn={isViewOnly === 1 ? false : true}
        handleSubmit={handleSubmit}
        isLoading={isLoading}
        allGetStarted={allGetStarted}
        overridden={overridden}
        isGetStartedAvailable={isGetStartedAvailable}
        handleExportClick={handlePDFExportClick}
        downloadLoading={downloadLoading}
        interactionConfigurations={interactionConfigurations}
      />

      {/* {allGetStarted && allGetStarted.length > 0 && (
        <>
          <ProcessDetailHeader
            allGetStarted={allGetStarted}
            setAllGetStarted={setAllGetStarted}
            isGetStartedAvailable={isGetStartedAvailable}
            title={getDisplayValue(allProcessData?.labelValue)}
            isLoading={isLoading}
          />
        </>
      )} */}
      {allProcessData && (
        <>
          <OptionOneMain
            allProcessData={allProcessData}
            setAllProcessData={setAllProcessData}
            isLoading={isLoading}
            isViewOnly={isViewOnly}
            validationErrors={validationErrors}
          />
        </>
      )}
      {pageLoader && <PageLoader />}
    </div>
  );
}
export default OptionOneWrapper;
